
import "./ContactSteps.css";

function ContactSteps({
  title,
  step1Title,
  step1Text,
  step2Title,
  step2Text,
  step3Title,
  step3Text,
}) {
  return (
    <section className="contact-steps-container">
      <div className="contact-steps-inner hover-lift">
        <h2>{title}</h2>
        <div className="contact-steps-list">
          <div className="contact-step">
            <span className="contact-step-index">1</span>
            <div className="contact-step-copy">
              <h3>{step1Title}</h3>
              <p>{step1Text}</p>
            </div>
          </div>

          <div className="contact-step">
            <span className="contact-step-index">2</span>
            <div className="contact-step-copy">
              <h3>{step2Title}</h3>
              <p>{step2Text}</p>
            </div>
          </div>

          <div className="contact-step">
            <span className="contact-step-index">3</span>
            <div className="contact-step-copy">
              <h3>{step3Title}</h3>
              <p>{step3Text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSteps;
